<template>
  <div :class="$style['chart-bar-group']">
    <adl-chart-bar-group
      :data="chartData"
      :rangeX="chartProperties.rangeX"
      :labelNameY="chartProperties.labelNameY"
      :rangeY="chartProperties.rangeY"
      :domainX="chartProperties.domainX"
      :domainY="chartProperties.domainY"
      :tickQuantityY="chartProperties.tickQuantityY"
      :color="chartProperties.color"
      :legendItems="chartProperties.legendItems"
      :legendKeyType="chartProperties.legendKeyType"
      :currencyFormat="chartProperties.currencyFormat"
      :height="chartProperties.height"
      :width="chartProperties.width"
      :axisLeftWidth="chartProperties.axisLeftWidth"
      :axisRightWidth="chartProperties.axisRightWidth"
      :toolTipWidth="chartProperties.toolTipBoxWidth"
      :isHideFirstTick="chartProperties.isHideFirstTick"
      @setTooltipData="setTooltipData"
    >
      <template v-slot:tooltipText>
        <mce-hover-flag v-if="mouse" :x="mouse.pageX" :y="mouse.pageY">
          <div ref="hover">
            <div
              :class="$style['tooltipbox']"
              :style="{ width: toolTipWidth + 'px' }"
            >
              <mds-table fixed-first-col>
                <mds-thead>
                  <mds-th
                    v-for="(header, hindex) in filteredtooltipHeader"
                    :key="hindex"
                  >
                    <template v-if="header.type == 'text'">
                      {{ header.value }}</template
                    >
                    <template v-if="header.type == 'legendText'">
                      <mce-legend hideTopBorder hideBottomBorder>
                        <mce-legend-item
                          :label="header.value"
                          :class="$style['legendG']"
                          stacked
                          key-type="bar"
                          :line-weight="2"
                          :color="header.color"
                        ></mce-legend-item>
                      </mce-legend>
                    </template>
                  </mds-th>
                </mds-thead>
                <mds-tbody>
                  <mds-tr
                    v-for="(prop, rowindex) in tooltipDataProp"
                    :key="rowindex"
                  >
                    <mds-td v-if="prop.name">
                      <strong
                        v-if="prop.isBold"
                        :style="prop.isLMargin ? LAlign : ''"
                      >
                        {{ prop.name }}</strong
                      >

                      <span :style="prop.isLMargin ? LAlign : ''" v-else>
                        {{ prop.name }}</span
                      >
                    </mds-td>
                    <mds-td v-else>{{ prop }} </mds-td>

                    <mds-td
                      v-for="(row, columnindex) in filteredtooltipData"
                      :key="columnindex"
                    >
                      {{ row[prop.name ? prop.name : prop] }}
                    </mds-td>
                  </mds-tr>
                </mds-tbody>
              </mds-table>
            </div>
          </div>
        </mce-hover-flag>
      </template>
    </adl-chart-bar-group>
  </div>
</template>
<script>
import AdlChartBarGroup from "../custom/chart-bar-group/ChartBarGroup.vue";
import { MceLegend, MceLegendItem } from "@mce/legend";
import MceHoverFlag from "@mce/hover-flag";
import { ChartToolTip } from "../../mixin";
import {
  MdsTable,
  MdsThead,
  MdsTh,
  MdsTbody,
  MdsTr,
  MdsTd,
} from "@mds/data-table";
export default {
  mixins: [ChartToolTip],
  props: {
    chartProperties: {
      type: Object,
    },

    chartData: {
      type: Array,
    },

    tooltipHeader: {
      type: Array,
    },
    tooltipData: {
      type: Array,
    },
    tooltipDataProp: {
      type: Array,
    },
  },

  data() {
    return {
      userSelectedHoverPosition: {},
      enableLegendInfo: [],
      filteredtooltipHeader: [],
      mouse: null,
      padding: 20,
      paddingLeft: 50,
    };
  },
  computed: {
    LAlign() {
      return { paddingLeft: "10px" };
    },
    toolTipWidth() {
      return this.chartProperties.toolTipBoxWidth;
    },
    filteredtooltipData() {
      let rows = this.tooltipData.filter(
        (sr) => sr.id == this.userSelectedHoverPosition._itemId
      );
      let userSelectedToolTipRows = [];
      if (rows.length > 0) {
        for (let j = 0; j < rows[0].value.length; j++) {
          for (let i = 0; i < this.enableLegendInfo.length; i++) {
            if (j == this.enableLegendInfo[i]) {
              userSelectedToolTipRows.push(rows[0].value[j].value);
            }
          }
        }
      }
      return userSelectedToolTipRows;
    },
  },
  components: {
    AdlChartBarGroup,
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    MceLegend,
    MceLegendItem,
    MceHoverFlag,
  },
  methods: {
    setHeaderText() {
      let rows = this.tooltipData.filter(
        (sr) => sr.id == this.userSelectedHoverPosition._itemId
      );
      if (
        rows.length > 0 &&
        rows[0].value.length > 0 &&
        rows[0].value[0].value &&
        rows[0].value[0].value.graphTitle
      ) {
        this.tooltipHeader[0].value = rows[0].value[0].value.graphTitle;
      }
    },
    getFilteredtooltipHeader() {
      let cloneToolTipHeader = Object.assign([], this.tooltipHeader);
      let userSelectedToolTipHeader = [];
      userSelectedToolTipHeader.push(cloneToolTipHeader[0]);
      for (let j = 1; j < cloneToolTipHeader.length; j++) {
        for (let i = 0; i < this.enableLegendInfo.length; i++) {
          if (j - 1 == this.enableLegendInfo[i]) {
            userSelectedToolTipHeader.push(cloneToolTipHeader[j]);
          }
        }
      }
      return userSelectedToolTipHeader;
    },
    async setTooltipData(data, legendData, mouse) {
      this.mouse = mouse;
      if (mouse) {
        if (data._itemId) {
          this.userSelectedHoverPosition = data;

          this.tooltipHeader[0].value = data._itemId;
          this.setHeaderText();
          this.enableLegendInfo = legendData;
          this.filteredtooltipHeader = this.getFilteredtooltipHeader();
        }
        if (
          window.innerWidth - this.toolTipWidth - this.paddingLeft <
          this.mouse.pageX
        ) {
          this.mouse.pageX =
            window.innerWidth - this.toolTipWidth - this.paddingLeft;
        }
        if (this.mouse && this.mouse.pageY) {
          await this.resetToolTipHeight(this.padding);
        }
      }
    },
  },
};
</script>
<style lang="scss" module>
.chart-bar-group {
  .mds-th {
    vertical-align: top !important;
  }
  .legendG > span {
    margin-top: 8px !important;
    width: 100px;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
    overflow: hidden;
  }
  .legendG {
    overflow: hidden;
  }
  .tooltipbox {
    padding: 20px;
  }
  .mce-hover-flag {
    max-width: initial !important;
  }
}
</style>
